import {getValidStructure} from 'hooks/QFP/Shared';
import React from 'react';
import {Menu} from 'components/customer/AdvancedMaterials/entity/Menu';
import styled, {css} from 'styled-components';
import {touchDevices} from 'shared/Breakpoints';
import {
    Label,
    ProductAdvancedMaterials,
} from 'components/customer/Product/Specs/Materials/DoorStyle';
import {useMaterialType} from 'components/customer/Product/Specs/helpers/useMaterialType';
import {useAutoButtonClick} from 'components/customer/Product/Specs/helpers/useAutoButtonClick';
import {Page} from 'store/customer/entity/Page';

interface MaterialProps {
    isMiniBrowser?: boolean;
    isExterior: boolean;
    thumb: JSX.Element;
    productInfo?: Partial<ReturnType<typeof getValidStructure>>;
    page?: Page;
}

export const Material = ({
    isMiniBrowser,
    isExterior,
    thumb,
    productInfo,
    page = Page.PRODUCT,
}: MaterialProps) => {
    const {materialType, cabinetType} = useMaterialType(isExterior);
    const {buttonRef, handleClick} = useAutoButtonClick();

    return (
        <ThumbContainer $isMiniBrowser={isMiniBrowser} $isExterior={isExterior}>
            {isExterior ? (
                <Label $isMiniBrowser={isMiniBrowser}>Material</Label>
            ) : (
                <br />
            )}
            <div onClick={handleClick}>{thumb}</div>
            <ColorBrowserButtonContainer>
                <ProductAdvancedMaterials
                    materialType={materialType}
                    cabinetType={cabinetType}
                    hasDoors={(isExterior && productInfo?.hasDoors) || false}
                    defaultMenu={Menu.MATERIAL}
                    buttonText="Change Material"
                    buttonRef={buttonRef}
                    page={page}
                />
            </ColorBrowserButtonContainer>
        </ThumbContainer>
    );
};

const mobileThumbContainer = (isExterior: boolean) => css`
    width: 45%;
    min-height: 175px;

    > br {
        display: none;
    }

    > div:last-child {
        width: 50%;

        > button {
            width: 100% !important;
        }
    }

    ${!isExterior ? `margin-top: 15px;` : ''}
`;

const ThumbContainer = styled.div<{
    $isMiniBrowser?: boolean;
    $isExterior?: boolean;
}>`
    .thumbnail-container {
        margin-top: 0px;
    }

    align-items: center;

    ${({$isMiniBrowser, $isExterior}) =>
        $isMiniBrowser && mobileThumbContainer($isExterior ?? false)}

    ${touchDevices<{$isExterior?: boolean}>`
        ${({$isExterior}) => mobileThumbContainer($isExterior ?? false)}
    `}
`;

const ColorBrowserButtonContainer = styled.div`
    margin-top: 25px;
`;
